import { render, staticRenderFns } from "./AddEditForm.vue?vue&type=template&id=1f8fa0e6"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"
import style0 from "./AddEditForm.vue?vue&type=style&index=0&id=1f8fa0e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports